export default __webpack_public_path__ + "static/media/il-local-road.4ae20cac.svg";